export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/a2cdf02300b2663230f496dbfe02b4a0.svg";